import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { addFavourite, removeFavourite } from './favorite.api';
import { FAVOURITE_LISTINGS_QUERY_KEY } from './favorite.query';

export const useAddFavorite = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addFavourite,
    onSuccess: () => {
      toast.success('Added to favorites');
      queryClient.invalidateQueries({ queryKey: [FAVOURITE_LISTINGS_QUERY_KEY] });
    },
  });
};

export const useRemoveFavorite = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: removeFavourite,
    onSuccess: () => {
      toast.success('Removed from favorites');
      queryClient.invalidateQueries({ queryKey: [FAVOURITE_LISTINGS_QUERY_KEY] });
    },
  });
};
